import React from "react";

import formatCurrency from "Utils/formatCurrency";

import { Table, TR, TH, TD, HeaderTR, SnugTD, EllipsisTD } from "Cobalt/TableV2";
import ColoredDot from "Common/ColoredDot";
import { Div } from "Common/HTML";
import type { PlanDeviationProps } from "Common/PlanLoader/Selectors";

import type { MedicalPlanPrice } from "Utils/types";

import makeBem from "Utils/makeBem";

const bem = makeBem("ServiceCostsTable");

export const ServiceCostsTable = ({
  plan,
  planDeviation = {},

  /** If the page is loading, do not render colored dots - they are dynamically calculated based on all available plans */
  loading,
  ...props
}: {
  plan: MedicalPlanPrice;
  planDeviation?: PlanDeviationProps;
}) => (
  <Div className={bem()} {...props}>
    <Table>
      <thead>
        <HeaderTR>
          <TH>Service</TH>
          <TH align="right" />
          <TH align="left">Expected Cost</TH>
          <TH width="48%" align="left">
            Details
          </TH>
        </HeaderTR>
      </thead>
      <tbody>
        <TR highlightFirstCell={false}>
          <TD>Specialist Visit</TD>
          <SnugTD>
            {!loading && (
              <ColoredDot
                color={plan.colored_dots.specialist_visit}
                value={plan.estimated_costs.specialist_visit}
                mean={planDeviation.mean_specialist_visit}
                stdev={planDeviation.stdev_specialist_visit}
              />
            )}
          </SnugTD>
          <TD>{formatCurrency(plan.estimated_costs.specialist_visit)}</TD>
          <EllipsisTD align="left">{plan.fine_print_updated.specialist_visit.join("")}</EllipsisTD>
        </TR>
        <TR highlightFirstCell={false}>
          <TD>Emergency Room</TD>
          <SnugTD>
            {!loading && (
              <ColoredDot
                color={plan.colored_dots.emergency_room}
                value={plan.estimated_costs.emergency_room}
                mean={planDeviation.mean_emergency_room}
                stdev={planDeviation.stdev_emergency_room}
              />
            )}
          </SnugTD>
          <TD>{formatCurrency(plan.estimated_costs.emergency_room)}</TD>
          <EllipsisTD align="left">{plan.fine_print_updated.emergency_room.join("")}</EllipsisTD>
        </TR>
        <TR highlightFirstCell={false}>
          <TD>Mental Health</TD>
          <SnugTD>
            {!loading && (
              <ColoredDot
                color={plan.colored_dots.mental_health}
                value={plan.estimated_costs.mental_health}
                mean={planDeviation.mean_mental_health}
                stdev={planDeviation.stdev_mental_health}
              />
            )}
          </SnugTD>
          <TD>{formatCurrency(plan.estimated_costs.mental_health)}</TD>
          <EllipsisTD align="left">{plan.fine_print_updated.mental_health.join("")}</EllipsisTD>
        </TR>
      </tbody>
    </Table>
  </Div>
);
